const surveyInfo = payload => {
  return {
    type: "surveycondition",
    payload
  };
};

export default surveyInfo;
